export default __webpack_public_path__ + "static/media/location.91a62d7b.svg";